import React from "react";
import "./Impressum.css"; // CSS für zentrierten Text
import Footer from "./Footer";

const Impressum = () => {
  return (
    <div className="impressum-container">
      <h1>Impressum</h1>
      <p>Marlon Soyka - BuBu</p>
      <p>GetHero</p>
      <p>c/o Webedia GmbH</p>
      <p>Cuvrystr. 3-4</p>
      <p>10997 Berlin</p>
      <p>E-Mail: <a href="mailto:business.pokebubu@gmx.de">business.pokebubu@gmx.de</a></p>
      <p>Geschäftsführer: Marc-Andreas Albert</p>
      <p>HRB 114531</p>
      <p>Inhaltlich Verantwortlicher gemäß § 18 Abs.2 MStV: Marlon Soyka</p>
      <p>Telefon: +49 (0) 89 244 136 705</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      
      <Footer />
    </div>
    
  );
  
};

export default Impressum;
